/**
 * @generated SignedSource<<7d7970533a9c0286530550b3947b624e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioPeriod = "DAY" | "MAX" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type PortfolioHiststoricalDataQuery$variables = {
  period: PortfolioPeriod;
};
export type PortfolioHiststoricalDataQuery$data = {
  readonly portfolio: {
    readonly historicalData: ReadonlyArray<{
      readonly period: string | null | undefined;
      readonly value: PrecisionFloat | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type PortfolioHiststoricalDataQuery = {
  response: PortfolioHiststoricalDataQuery$data;
  variables: PortfolioHiststoricalDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "period"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "period",
            "variableName": "period"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "portfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HistoricalValue",
        "kind": "LinkedField",
        "name": "historicalData",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "period",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioHiststoricalDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioHiststoricalDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ac111be4d0a72c98603d56ce14b6a03",
    "id": null,
    "metadata": {},
    "name": "PortfolioHiststoricalDataQuery",
    "operationKind": "query",
    "text": "query PortfolioHiststoricalDataQuery(\n  $period: PortfolioPeriod!\n) {\n  portfolio(input: {period: $period}) {\n    historicalData {\n      value\n      period\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7474e2c830f7105ba08644d37f227327";

export default node;
